<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper/modules';
import { sanitizeUrl } from '@braintree/sanitize-url';

export default {
    props: {
        title: String,
        items: Array,
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Pagination, Navigation],
        };
    },
    data() {
        return {
            breakpoints: {
                992: {
                    spaceBetween: 0,
                },
            },
        };
    },
    methods: {
        sanitize(url) {
            return sanitizeUrl(url);
        },
    },
};
</script>
<template>
    <div
        class="fs-24px fw-light tw-text-white tw-bg-accentGreen text-center text-uppercase py-11px"
    >
        {{ title }}
    </div>
    <swiper
        :pagination="true"
        :navigation="true"
        :modules="modules"
        :centeredSlides="false"
        :step="1"
        :slidesPerView="1"
        :spaceBetween="0"
        :breakpoints="breakpoints"
    >
        <swiper-slide v-for="(item, index) in items">
            <div class="swiper-img-wrapper">
                <img
                    :src="item.image_link"
                    class="content__img-banner img-fluid"
                />
            </div>
            <div class="swiper-content">
                <h1
                    class="fs-8px fs-12px-lg fw-semibold tw-text-accentGreen content__sub-title"
                    v-for="(tag, index) in item.tags"
                >
                    {{ tag.estate.name }}
                </h1>
                <h2
                    class="fs-20px fs-24px-lg fw-semibold tw-text-darkGreen content__title"
                >
                    {{ item.title }}
                </h2>
                <div
                    class="fs-12px fw-medium tw-text-dakrGreen content__date"
                    v-for="(created_at, index) in item.formattedDate"
                >
                    {{ created_at }}
                </div>
                <div
                    class="d-none fs-16px fw-semibold tw-text-darkGreen promo-description"
                    v-for="(
                        short_description, index
                    ) in item.formattedDescription"
                >
                    {{ short_description }}
                </div>
                <div class="content__link">
                    <a
                        :href="this.sanitize(item.link)"
                        class="fs-12px fs-14px-lg fw-bold tw-text-midGreen hover:tw-text-midGreen text-decoration-none"
                    >
                        READ MORE
                        <i
                            aria-hidden="true"
                            class="fa fa-chevron-right fw-bold ml-12px fs-10px pb-2px"
                        ></i>
                    </a>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>
